module.exports = __webpack_public_path__ + "static/media/HaluGen - Psychedelics and Genetic Pre-Screening White Paper.9956ff08.pdf";